import React, {Component} from 'react';
import { connect } from 'react-redux';
import {resetPassword} from '../../action/loginAction.js';
import NavigatorMain from '../NavigatorMain';
import Util from '../../util.js';
import { Toast } from 'antd-mobile/lib';
import { hashHistory } from 'react-router';


class SetNewPassword extends Component{
  state={
    mobileNumber: this.props.location.state ? this.props.location.state.mobileNumber : "",
    newPassword: '',
    checkPassword: '',
    secureTextEntryForNewPassword: true,
    secureTextEntryForCheckPassword: true,
    flag: false,
    passType: "password",
    passTypeAgin: "password"
  };

  handleSetNewPassword = () => {
    let encryptedPassword = Util.encrypt(this.state.newPassword);

    let pattern = /^[\d,\w]{6,8}$/;
    if(!pattern.test(this.state.newPassword)){
      let toast = Toast.info('密码格式不正确', 2);
      return;
    }

    if(this.state.newPassword != this.state.checkPassword){
      Toast.info('密码不一致', 2);
      return;
    }
    
    let setNewPasswordParam = {
      mobileNo: this.state.mobileNumber,
      newPassword: encryptedPassword,
    }
    this.setState({
      flag: true
    })
    this.props.dispatch(resetPassword( setNewPasswordParam, (msg)=>{this.syncSuccess(msg)}, (msg)=>{this.syncError(msg)}));
  }

  syncError = (msg) => {
    this.setState({
      flag: false
    });
    Toast.info(msg, 2);
  }

  syncSuccess = () => {
    this.setState({
      flag: false
    });
    //跳转到登录前的页面。
    // Toast.info(msg, 2);
    hashHistory.go(-3);
  }

  changePassword = (event) => {
    this.setState({
      newPassword: event.target.value
    });
  }

  changeCkPassword = (event) => {
    this.setState({
      checkPassword: event.target.value
    });
  }

  goBack = () => {
    hashHistory.goBack();
  }

  componentWillMount() {
    document.title = "设置登录密码";
  }

  render(){
    let { passType, passTypeAgin } = this.state;
    return(
      <div className="mainBox"> 
        <NavigatorMain>
          <div className="boxHeader">
            <div>
              <img onClick={this.goBack} src={require("../../img/leftArrow_header.png")} />
            </div>
            <div>
              <span>设置登录密码</span>
            </div>
            <div>
              
            </div>
          </div>
        </NavigatorMain> 
        <div className="boxContent">
          <div style={{
              width:'auto',
              height: 45,
              marginTop: 7,
              marginLeft: 13,
              marginRight: 13,
              backgroundColor: '#ffffff',
              WebkitFlexDirection: 'row',
              WebkitAlignItems: 'center',
              borderRadius: 22,
              border:"1px solid #eaeded",
              position: "relative",
              display: "-webkit-flex"
          }}>
           <span style={{paddingLeft: 13, color: "#3a3e47", fontSize: 14, width: 100}}>登录密码</span> 
           <div style={{
            display: "-webkit-flex",
            WebkitFlexDirection: 'row',
            WebkitAlignItems: 'center',
            WebkitFlex: 1
           }}>
            <input autocomplete="off" onChange={this.changePassword} value={this.state.newPassword} type={passType} style={{WebkitFlex: 1, fontSize: 14, color: "#3a3e47", height: 40}} placeholder="请输入6-8位登录密码" /> 
            {
              this.state.secureTextEntryForNewPassword ? 
              <img onClick={()=>this.setState({secureTextEntryForNewPassword: !this.state.secureTextEntryForNewPassword, passType: "text"})}  alt="" style={{height: 40, width: 40}} src={require("../../img/password_unhide.png")} />
              :
              <img onClick={()=>this.setState({secureTextEntryForNewPassword: !this.state.secureTextEntryForNewPassword, passType: "password"})}  alt="" style={{height: 40, width: 40}} src={require("../../img/password_hide.png")} />
            }
           </div>
          </div>
          <div style={{
              width:'auto',
              height: 45,
              marginTop: 7,
              marginLeft: 13,
              marginRight: 13,
              backgroundColor: '#ffffff',
              WebkitFlexDirection: 'row',
              WebkitAlignItems: 'center',
              borderRadius: 22,
              border:"1px solid #eaeded",
              position: "relative",
              display: "-webkit-flex"
          }}>
           <span style={{paddingLeft: 13, color: "#3a3e47", fontSize: 14, width: 100}}>确认密码</span> 
           <div style={{
            display: "-webkit-flex",
            WebkitFlexDirection: 'row',
            WebkitAlignItems: 'center',
            WebkitFlex: 1
           }}>
            <input autocomplete="off" onChange={this.changeCkPassword} value={this.state.checkPassword} type={passTypeAgin} style={{WebkitFlex: 1, fontSize: 14, color: "#3a3e47", height: 40}} placeholder="请输入确认密码" /> 
            {
              this.state.secureTextEntryForCheckPassword ? 
              <img onClick={()=>this.setState({secureTextEntryForCheckPassword: !this.state.secureTextEntryForCheckPassword, passTypeAgin: "text"})}  alt="" style={{height: 40, width: 40}} src={require("../../img/password_unhide.png")} />
              :
              <img onClick={()=>this.setState({secureTextEntryForCheckPassword: !this.state.secureTextEntryForCheckPassword, passTypeAgin: "password"})}  alt="" style={{height: 40, width: 40}} src={require("../../img/password_hide.png")} />
            }
           </div>
          </div>
          <div  style = {{
            marginTop: 15,
            marginLeft: 13,
            marginRight: 13,
            borderRadius: 20
          }}  onClick = {this.state.newPassword && this.state.checkPassword ? this.handleSetNewPassword : null }>
            <div style = {{backgroundColor: this.state.newPassword && this.state.checkPassword ? '#fa063a' : '#afb0b2' ,WebkitAlignItems: 'center',WebkitJustifyContent: 'center',height: 40,borderRadius: 20,WebkitFlexDirection: 'row',display: "-webkit-flex"}}>
              <span style = {{color: '#ffffff', fontSize: 15}}>完成</span>
            </div>
          </div>
        </div>
      </div>
    )
  }
} 

const mapStateToProps = (state, ownProps) => {
  return {
  }
}

export default connect(mapStateToProps)(SetNewPassword);


// WEBPACK FOOTER //
// ./src/components/login/SetNewPassword.js